const setFormListeners = () => {
  const forms = document.querySelectorAll(".card__sizes");

  forms.forEach((form) => {
    const submitButton = form.querySelector('[type="submit"]');
    const variantSizes = form.querySelectorAll(
      'input[type="radio"][data-option-value-id]'
    );

    const checked = [...variantSizes].some((r) => r.checked);
    if (submitButton) {
      submitButton.disabled = !checked;
    }

    variantSizes.forEach((sizeInput) => {
      sizeInput.addEventListener("change", () => {
        const selected = form.querySelector(
          'input[type="radio"][data-option-value-id]:checked'
        );

        if (submitButton) {
          submitButton.disabled = !selected;
        }

        variantSizes.forEach((input) => {
          const label = input.closest("label");
          if (label) label.classList.remove("size-selector__checked");
        });

        if (selected) {
          const selectedLabel = selected.closest("label");
          if (selectedLabel)
            selectedLabel.classList.add("size-selector__checked");
        }
      });
    });
  });
};

const setQuickAddButtons = () => {
  const btnsQuickAdd = document.querySelectorAll(".btn-quick-add-js");

  btnsQuickAdd.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();

      btn.classList.add("loading");

      const card = btn.closest(".card-product-plp");
      if (!card) return;

      const selectedSizeInput = card.querySelector(
        ".card__sizes input[data-option-value-id]:checked"
      );
      const selectedColorInput = card.querySelector(
        ".card__content .color-swatches input[data-color]:checked"
      );

      if (!selectedColorInput || !selectedSizeInput) {
        btn.classList.remove("loading");
        return;
      }

      const selectedColor = selectedColorInput.value.trim();
      const selectedSize = selectedSizeInput.value.trim();
      const variantTitle = `${selectedColor} / ${selectedSize}`
        .trim()
        .normalize();

      const variantsJson = card.querySelector(".qa-product-variants-json");
      if (!variantsJson) {
        btn.classList.remove("loading");
        return;
      }

      const variants = JSON.parse(variantsJson.innerHTML);
      const matchedVariant = variants.find(
        (variant) => variant.title.trim().normalize() === variantTitle
      );

      if (!matchedVariant) {
        btn.classList.remove("loading");
        return;
      }

      const formData = {
        items: [
          {
            id: matchedVariant.id,
            quantity: 1,
          },
        ],
      };

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        .then(async (addResp) => {
          const response = await fetch(
            `${window.Shopify.routes.root}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble`
          );
          const sectionHTML = await response.json();
          return {
            key: addResp.key,
            sections: sectionHTML,
          };
        })
        .then((parsedState) => {
          const cartNotif = document.querySelector("cart-notification");
          cartNotif?.renderContents(parsedState);
        })
        .catch((error) => {
          console.error("Error adding to cart: ", error);
        })
        .finally(() => {
          btn.classList.remove("loading");
        });
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  setFormListeners();
  setQuickAddButtons();
});

window.setFormListeners = setFormListeners;
window.setQuickAddButtons = setQuickAddButtons;
